import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import * as React from 'react';
import { Radio, RadioProps } from 'antd';

export interface IEmrRadioProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<RadioProps, 'name'> {}

const EmrRadio: React.FC<IEmrRadioProps> = ({ disabled, field, name, labelProps = {}, ...rest }) => {
  return (
    <EmrFormItem field={field} name={name} initialValue={disabled ? undefined : field?.default} {...labelProps}>
      <Radio.Group
        className="w-full flex justify-between"
        options={
          field?.extra?.options?.map((o: any) => ({
            label: <span style={{ color: o.color }}>{o.label}</span>,
            value: o.value,
          })) || field?.enum?.split(',').map((o: string) => ({ label: o, value: o?.trim() }))
        }
        {...rest}
        disabled={disabled}
      />
    </EmrFormItem>
  );
};
export default EmrRadio;
